import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createSlots as _createSlots, withModifiers as _withModifiers, withKeys as _withKeys } from "vue"
import _imports_0 from '@/assets/img/payoneer-logo.svg'


const _hoisted_1 = { class: "b-sign-up" }
const _hoisted_2 = ["href"]
const _hoisted_3 = ["href"]
const _hoisted_4 = { class: "b-sign-up__sign-in-btn" }
const _hoisted_5 = { class: "flex middle-xs center-xs" }
const _hoisted_6 = { class: "regular black" }
const _hoisted_7 = { class: "black regular" }
const _hoisted_8 = { class: "flex middle-xs between-xs" }
const _hoisted_9 = {
  key: 0,
  width: "80",
  height: "16",
  src: _imports_0,
  alt: "Payoneer logo"
}
const _hoisted_10 = { class: "b-sign-up_card_number flex middle-xs black" }
const _hoisted_11 = {
  key: 0,
  class: "bold"
}
const _hoisted_12 = {
  key: 1,
  class: "regular"
}
const _hoisted_13 = {
  key: 2,
  class: "b-sign-up_card_number_separator"
}
const _hoisted_14 = {
  key: 0,
  class: "regular black"
}
const _hoisted_15 = {
  key: 1,
  class: "regular transparent-grey"
}
const _hoisted_16 = {
  key: 0,
  class: "b-sign-up__payoneer-field"
}
const _hoisted_17 = ["href"]
const _hoisted_18 = ["href"]
const _hoisted_19 = {
  key: 1,
  class: "bin-invalid"
}
const _hoisted_20 = { class: "black bold" }
const _hoisted_21 = { class: "black regular" }
const _hoisted_22 = { class: "black regular" }
const _hoisted_23 = {
  key: 2,
  class: "b-bin-form"
}
const _hoisted_24 = { class: "flex middle-xs" }
const _hoisted_25 = { class: "black regular" }
const _hoisted_26 = {
  key: 1,
  class: "b-sign-up__sign-in-btn"
}
const _hoisted_27 = { class: "flex middle-xs center-xs" }
const _hoisted_28 = { class: "regular black" }

import {
    ref,
    computed,
    ComputedRef,
    watch,
    nextTick,
    onMounted,
    onBeforeUnmount,
  } from 'vue';
  import { useStore } from 'vuex';
  import { useI18n } from 'vue-i18n';
  import { User } from 'types';
  import { UserService } from 'api';
  import { Events } from '@/analytics';
  import { isIOSChrome } from '@/plugins';
  import { SonicSdk } from '@/mc-sonic/sonicSdk';
  import InputComponent from '@/views/components/InputComponent.vue';
  import ButtonComponent from '@/views/components/ButtonComponent.vue';
  import SpinnerComponent from '@/views/components/SpinnerComponent.vue';
  import PincodeInputComponent from '@/views/components/PincodeInputComponent';
  import EmailConfirmComponent from './EmailConfirmComponent.vue';
  import SignUpConsent from './SignUp/Consent.vue';
  import { MCSymbolIcon, CreditCard48, CheckIcon } from '@/views/icons';
  import { mergeMap } from 'rxjs/operators';
  import { GeoIpService } from '@/api';
  import { readQuery } from '@/utils';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'SignUpComponent',
  setup(__props) {

  const { t } = useI18n();
  const store = useStore();

  const emailRef = ref<InstanceType<typeof InputComponent>>(null);
  const binRef = ref<InstanceType<typeof PincodeInputComponent>>(null);

  const checkEligibilityBtnRef =
    ref<InstanceType<typeof ButtonComponent>>(null);
  const emailConfirmRef = ref<InstanceType<typeof EmailConfirmComponent>>(null);

  const isConsentRequired = ref<boolean>(false);
  const isConsentAccepted = ref<boolean>(false);

  const bank = ref<string | null>(null);

  const binForm = ref<User.CheckBinForm>(new User.CheckBinForm());
  const signUpForm = ref<User.SignUpForm>(new User.SignUpForm());

  const cardIcon = computed(() =>
    binForm.value.isMastercard() ? MCSymbolIcon : CreditCard48,
  );

  const isMobile: ComputedRef<boolean> = computed(
    () => store.state.support.isMobile,
  );

  const userCategory: ComputedRef<User.UserCategory.Category> = computed(
    () => store.state.user.category,
  );

  const termsLinkByLocale = computed(
    () => store.getters['support/termsLinkByLocale'],
  );

  const privacyPolicyLinkByLocale = computed(
    () => store.getters['support/privacyPolicyLinkByLocale'],
  );

  const isSubmitEnable: ComputedRef<boolean> = computed(
    () =>
      signUpForm.value.email.value.length > 0 &&
      signUpForm.value.firstName.value.length > 0 &&
      signUpForm.value.lastName.value.length > 0 &&
      (signUpForm.value.fullCardNumberRequired()
        ? signUpForm.value.isFullCardNumberIsValid(binForm.value.bin.value)
        : true),
  );

  const cardNumberSplitted: ComputedRef<Array<string | null>> = computed(() => [
    ...binForm.value.bin.value.replace(' ', '').split(''),
    ...signUpForm.value.cardNumberLastDigits.value
      .replace(' ', '')
      .split('')
      .map(it => it ?? null),
  ]);

  function onFocus() {
    if (isIOSChrome() && emailRef.value) {
      emailRef.value.$el.scrollIntoView({ behavior: 'smooth' });
    }
  }

  function getRequestParams() {
    if (!signUpForm.value.isValid()) {
      return null;
    }

    signUpForm.value.isFilled = true;

    if (isConsentRequired.value && !isConsentAccepted.value) {
      return null;
    }

    const bin =
      userCategory.value === User.UserCategory.Category.Individual
        ? User.UserCategory.nonBusinessDefaultBin
        : binForm.value.bin.value;

    return signUpForm.value.createRequestBody(bin);
  }

  function applyFormEvent() {
    Events.Auth.applyForm(signUpForm.value.email.value);
  }

  function switchToSignIn() {
    store.commit('user/setRegisterDialogShown', false);
    store.commit('user/setAuthDialogShown', true);
    binForm.value.reset();
  }

  function goBackForm() {
    binForm.value.isBinChecked = false;
  }

  function onFullCardRequired(payload: User.ML.Response.Auth) {
    signUpForm.value.specialBinPayload = {
      fullPanRequired: payload.fullPanRequired,
      status: payload.status,
      message: payload.message,
      key: payload.key,
      partner: payload.partner,
    };
  }

  function checkBin() {
    binForm.value.resetError();
    binForm.value.isLoading = true;

    UserService.ML.register({
      bin: binForm.value.bin.value,
    })
      .subscribe(
        res => {
          binForm.value.isBinValid = true;
          binForm.value.isBinChecked = true;
          Events.Auth.binCheck(binForm.value.bin.value, 'success');

          SonicSdk.checkAndPlaySonic(binForm.value.bin.value);

          if (res.data && res.data.fullPanRequired) {
            onFullCardRequired(res.data);
          }
        },
        err => {
          if (err.header === 'BIN_NOT_VALID') {
            binForm.value.isBinValid = false;
            binForm.value.isBinChecked = true;
          } else if (err.message) {
            binForm.value.bin.error = err.message;
          }
          Events.Auth.binCheck(binForm.value.bin.value, 'error');
        },
      )
      .add(() => {
        binForm.value.isLoading = false;
      });
  }

  function onResize() {
    if (binRef.value) {
      binRef.value.inputRef.scrollIntoView({ behavior: 'smooth' });
    }
  }

  function onChangeEmail() {
    signUpForm.value.isFilled = false;
    isConsentRequired.value = false;
    nextTick(() => {
      if (emailRef.value?.input?.focus) {
        emailRef.value.input.focus();
      }
    });
  }

  async function handleConsentAccept() {
    isConsentAccepted.value = true;
    isConsentRequired.value = false;

    return emailConfirmRef.value.requestCode();
  }

  async function detectCountry() {
    isConsentRequired.value = false;
    isConsentAccepted.value = false;

    const listOfCountries = ['CN', 'HK', 'ID'];

    try {
      const country = await GeoIpService.getCountryByIp().toPromise();

      isConsentRequired.value = listOfCountries.some(it => it === country);
    } catch (error) {
      console.log(error);
    }
  }

  function getRegisterParamsFromQuery() {
    const bin = readQuery('bin8');
    const bankQuery = readQuery('bank');

    nextTick(() => {
      if (bin) {
        binForm.value.bin.value = bin;
      }

      if (bankQuery) {
        bank.value = decodeURIComponent(bankQuery);
      }
    });
  }

  watch(
    () => binForm.value.bin.value,
    () => {
      if (isMobile.value && binForm.value.isBinFilled()) {
        nextTick(() => {
          if (checkEligibilityBtnRef.value) {
            (checkEligibilityBtnRef.value.$el as HTMLButtonElement).focus();
          }
        });
      }
    },
  );

  onMounted(() => {
    detectCountry();
    getRegisterParamsFromQuery();

    window.addEventListener('resize', onResize, false);
  });

  onBeforeUnmount(() => {
    window.removeEventListener('resize', onResize, false);
  });

return (_ctx: any,_cache: any) => {
  const _component_i18n_t = _resolveComponent("i18n-t")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(userCategory) === _unref(User).UserCategory.Category.Individual)
      ? (_openBlock(), _createBlock(EmailConfirmComponent, {
          key: 0,
          bin: _unref(User).UserCategory.nonBusinessDefaultBin,
          isSubmitEnable: _unref(isSubmitEnable),
          email: signUpForm.value.email.value,
          getRequestParams: getRequestParams,
          onError: message => (signUpForm.value.email.error = message),
          onFullCardRequired: onFullCardRequired,
          applyFormEvent: applyFormEvent
        }, {
          formfields: _withCtx(({ isLoading }) => [
            _createVNode(InputComponent, {
              type: "text",
              name: "firstName",
              placeholder: _unref(t)('authModal.firstNameFieldPlaceholder'),
              value: signUpForm.value.firstName.value,
              readonly: isLoading,
              validate: signUpForm.value.firstName.validationEnabled,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => {
            signUpForm.value.firstName.value = $event.capitalize();
            signUpForm.value.firstName.validate();
          }),
              onChange: _cache[1] || (_cache[1] = ($event: any) => (signUpForm.value.firstName.validationEnabled = true)),
              errorText: signUpForm.value.firstName.error
            }, null, 8, ["placeholder", "value", "readonly", "validate", "errorText"]),
            _createVNode(InputComponent, {
              type: "text",
              name: "lastName",
              placeholder: _unref(t)('authModal.lastNameFieldPlaceholder'),
              value: signUpForm.value.lastName.value,
              readonly: isLoading,
              validate: signUpForm.value.lastName.validationEnabled,
              "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => {
            signUpForm.value.lastName.value = $event.capitalize();
            signUpForm.value.lastName.validate();
          }),
              onChange: _cache[3] || (_cache[3] = ($event: any) => (signUpForm.value.lastName.validationEnabled = true)),
              errorText: signUpForm.value.lastName.error
            }, null, 8, ["placeholder", "value", "readonly", "validate", "errorText"]),
            _createVNode(InputComponent, {
              ref_key: "emailRef",
              ref: emailRef,
              name: "email",
              type: "email",
              placeholder: _unref(t)('authModal.emailFieldPlaceholder'),
              value: signUpForm.value.email.value,
              validate: signUpForm.value.email.validationEnabled,
              readonly: isLoading,
              onFocus: _cache[4] || (_cache[4] = ($event: any) => (onFocus())),
              "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => {
            signUpForm.value.email.value = $event;
            signUpForm.value.email.validate();
          }),
              onChange: _cache[6] || (_cache[6] = ($event: any) => (signUpForm.value.email.validationEnabled = true)),
              errorText: signUpForm.value.email.error
            }, null, 8, ["placeholder", "value", "validate", "readonly", "errorText"])
          ]),
          policy: _withCtx(() => [
            _createVNode(_component_i18n_t, {
              keypath: "authModal.register.binValid.privacy",
              tag: "p",
              scope: "global"
            }, {
              terms: _withCtx(() => [
                _createElementVNode("a", {
                  href: _unref(termsLinkByLocale),
                  target: "_blank",
                  class: "grey",
                  rel: "noopener"
                }, _toDisplayString(_unref(t)('terms')), 9, _hoisted_2)
              ]),
              privacy: _withCtx(() => [
                _createElementVNode("a", {
                  href: _unref(privacyPolicyLinkByLocale),
                  target: "_blank",
                  class: "grey",
                  rel: "noopener"
                }, _toDisplayString(_unref(t)('privacy')), 9, _hoisted_3)
              ]),
              _: 1
            })
          ]),
          footer: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(t)('or')), 1)
              ]),
              _createVNode(ButtonComponent, {
                class: "bordered no-text-transform black",
                onClick: _cache[7] || (_cache[7] = ($event: any) => (switchToSignIn()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('signIn')), 1)
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["bin", "isSubmitEnable", "email", "onError"]))
      : (binForm.value.isBinChecked)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (binForm.value.isBinValid)
              ? (_openBlock(), _createBlock(EmailConfirmComponent, {
                  key: 0,
                  ref_key: "emailConfirmRef",
                  ref: emailConfirmRef,
                  bin: binForm.value.bin.value,
                  isSubmitEnable: _unref(isSubmitEnable),
                  email: signUpForm.value.email.value,
                  getRequestParams: getRequestParams,
                  applyFormEvent: applyFormEvent,
                  onError: message => (signUpForm.value.email.error = message),
                  onFullCardRequired: onFullCardRequired,
                  isConsentRequired: isConsentRequired.value,
                  isConsentAccepted: isConsentAccepted.value,
                  onOnChangeEmail: onChangeEmail
                }, _createSlots({
                  default: _withCtx(() => [
                    (isConsentRequired.value && signUpForm.value.isFilled)
                      ? (_openBlock(), _createBlock(SignUpConsent, {
                          key: 0,
                          onAccept: handleConsentAccept
                        }))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createElementVNode("p", _hoisted_7, _toDisplayString(signUpForm.value.fullCardNumberRequired()
                ? _unref(t)('authModal.register.payoneer.text')
                : _unref(t)('authModal.register.binValid.text')), 1),
                          _createElementVNode("div", {
                            class: "b-sign-up_card flex col",
                            onClick: _cache[8] || (_cache[8] = ($event: any) => (goBackForm()))
                          }, [
                            _createElementVNode("div", _hoisted_8, [
                              (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(cardIcon)), { size: "32" })),
                              (signUpForm.value.isPayoneer())
                                ? (_openBlock(), _createElementBlock("img", _hoisted_9))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_10, [
                              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(16, (i) => {
                                return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
                                  (_unref(cardNumberSplitted)[i - 1])
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_unref(cardNumberSplitted)[i - 1]), 1))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_12, "x")),
                                  ([4, 8, 12].includes(i))
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_13))
                                    : _createCommentVNode("", true)
                                ], 64))
                              }), 64))
                            ]),
                            (signUpForm.value.fullName())
                              ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(signUpForm.value.fullName()), 1))
                              : (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(_unref(t)('authModal.cardholder')), 1))
                          ])
                        ], 64))
                  ]),
                  _: 2
                }, [
                  (!(isConsentRequired.value && signUpForm.value.isFilled))
                    ? {
                        name: "formfields",
                        fn: _withCtx(({ isLoading }) => [
                          (signUpForm.value.fullCardNumberRequired())
                            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                _createVNode(InputComponent, {
                                  type: "card",
                                  customMask: "#### ####",
                                  name: "cardnumber-last-digits",
                                  placeholder: 
                _unref(t)('authModal.register.payoneer.lastDigitsFieldPlaceholder')
              ,
                                  value: signUpForm.value.cardNumberLastDigits.value,
                                  readonly: isLoading,
                                  validate: signUpForm.value.cardNumberLastDigits.validationEnabled,
                                  "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => {
                signUpForm.value.cardNumberLastDigits.value = $event;
                signUpForm.value.isCardNumberLastDigitsValid = false;
              }),
                                  onChange: _cache[10] || (_cache[10] = ($event: any) => {
                signUpForm.value.cardNumberLastDigits.validationEnabled = true;
                signUpForm.value.isFullCardNumberIsValid(binForm.value.bin.value);
              }),
                                  errorText: signUpForm.value.cardNumberLastDigits.error
                                }, null, 8, ["placeholder", "value", "readonly", "validate", "errorText"]),
                                (signUpForm.value.isCardNumberLastDigitsValid)
                                  ? (_openBlock(), _createBlock(_unref(CheckIcon), {
                                      key: 0,
                                      class: "b-sign-up__payoneer-field_check"
                                    }))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true),
                          _createVNode(InputComponent, {
                            type: "text",
                            name: "firstName",
                            placeholder: _unref(t)('authModal.firstNameFieldPlaceholder'),
                            value: signUpForm.value.firstName.value,
                            readonly: isLoading,
                            validate: signUpForm.value.firstName.validationEnabled,
                            "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => {
              signUpForm.value.firstName.value = $event.capitalize();
              signUpForm.value.firstName.validate();
            }),
                            onChange: _cache[12] || (_cache[12] = ($event: any) => (signUpForm.value.firstName.validationEnabled = true)),
                            errorText: signUpForm.value.firstName.error
                          }, null, 8, ["placeholder", "value", "readonly", "validate", "errorText"]),
                          _createVNode(InputComponent, {
                            type: "text",
                            name: "lastName",
                            placeholder: _unref(t)('authModal.lastNameFieldPlaceholder'),
                            value: signUpForm.value.lastName.value,
                            readonly: isLoading,
                            validate: signUpForm.value.lastName.validationEnabled,
                            "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => {
              signUpForm.value.lastName.value = $event.capitalize();
              signUpForm.value.lastName.validate();
            }),
                            onChange: _cache[14] || (_cache[14] = ($event: any) => (signUpForm.value.lastName.validationEnabled = true)),
                            errorText: signUpForm.value.lastName.error
                          }, null, 8, ["placeholder", "value", "readonly", "validate", "errorText"]),
                          _createVNode(InputComponent, {
                            ref_key: "emailRef",
                            ref: emailRef,
                            name: "email",
                            type: "email",
                            placeholder: _unref(t)('authModal.emailFieldPlaceholder'),
                            value: signUpForm.value.email.value,
                            validate: signUpForm.value.email.validationEnabled,
                            readonly: isLoading,
                            onFocus: _cache[15] || (_cache[15] = ($event: any) => (onFocus())),
                            "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => {
              signUpForm.value.email.value = $event;
              signUpForm.value.email.validate();
            }),
                            onChange: _cache[17] || (_cache[17] = ($event: any) => (signUpForm.value.email.validationEnabled = true)),
                            errorText: signUpForm.value.email.error
                          }, null, 8, ["placeholder", "value", "validate", "readonly", "errorText"])
                        ])
                      }
                    : undefined,
                  (!(isConsentRequired.value && signUpForm.value.isFilled))
                    ? {
                        name: "policy",
                        fn: _withCtx(() => [
                          _createVNode(_component_i18n_t, {
                            keypath: "authModal.register.binValid.privacy",
                            tag: "p",
                            scope: "global"
                          }, {
                            terms: _withCtx(() => [
                              _createElementVNode("a", {
                                href: _unref(termsLinkByLocale),
                                target: "_blank",
                                class: "grey",
                                rel: "noopener"
                              }, _toDisplayString(_unref(t)('terms')), 9, _hoisted_17)
                            ]),
                            privacy: _withCtx(() => [
                              _createElementVNode("a", {
                                href: _unref(privacyPolicyLinkByLocale),
                                target: "_blank",
                                class: "grey",
                                rel: "noopener"
                              }, _toDisplayString(_unref(t)('privacy')), 9, _hoisted_18)
                            ]),
                            _: 1
                          })
                        ])
                      }
                    : undefined
                ]), 1032, ["bin", "isSubmitEnable", "email", "onError", "isConsentRequired", "isConsentAccepted"]))
              : (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  _createElementVNode("div", {
                    class: "flex middle-xs clickable",
                    onClick: _cache[18] || (_cache[18] = ($event: any) => (goBackForm()))
                  }, [
                    (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(cardIcon)), { size: "48" })),
                    _createElementVNode("span", _hoisted_20, _toDisplayString(binForm.value.binFormatted()), 1)
                  ]),
                  _createElementVNode("p", _hoisted_21, _toDisplayString(_unref(t)('authModal.register.binInvalid.text')), 1),
                  _createElementVNode("p", _hoisted_22, _toDisplayString(_unref(t)('authModal.register.binInvalid.subtext')), 1),
                  _createVNode(ButtonComponent, {
                    class: "no-shadow no-text-transform",
                    variant: "secondary",
                    onClick: _cache[19] || (_cache[19] = ($event: any) => (goBackForm()))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('back')), 1)
                    ]),
                    _: 1
                  })
                ]))
          ], 64))
        : (_openBlock(), _createElementBlock("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(cardIcon)), { size: "48" }))
            ]),
            _createVNode(_component_i18n_t, {
              keypath: "authModal.register.binForm.text",
              tag: "p",
              class: "black regular",
              scope: "global"
            }, {
              bank: _withCtx(() => [
                _createElementVNode("span", null, _toDisplayString(bank.value ?? _unref(t)('authModal.register.binForm.euBanks')), 1)
              ]),
              _: 1
            }),
            _createElementVNode("form", {
              novalidate: "",
              onSubmit: _cache[23] || (_cache[23] = _withModifiers(($event: any) => (checkBin()), ["prevent"])),
              onKeypress: _cache[24] || (_cache[24] = _withKeys(($event: any) => (checkBin()), ["enter"]))
            }, [
              _createVNode(_unref(PincodeInputComponent), {
                ref_key: "binRef",
                ref: binRef,
                "num-inputs": 8,
                "should-auto-focus": false,
                "input-type": "number",
                value: binForm.value.bin.value,
                "onUpdate:value": _cache[20] || (_cache[20] = ($event: any) => ((binForm.value.bin.value) = $event)),
                errorText: binForm.value.bin.error,
                onFocus: _cache[21] || (_cache[21] = ($event: any) => (binForm.value.isBinFocused = true)),
                onUnfocus: _cache[22] || (_cache[22] = ($event: any) => (binForm.value.isBinFocused = false))
              }, null, 8, ["value", "errorText"])
            ], 32),
            _createElementVNode("p", _hoisted_25, _toDisplayString(_unref(t)('authModal.register.binForm.subtext')), 1),
            (!_unref(isMobile) || binForm.value.isBinFilled())
              ? (_openBlock(), _createBlock(ButtonComponent, {
                  key: 0,
                  ref_key: "checkEligibilityBtnRef",
                  ref: checkEligibilityBtnRef,
                  variant: "secondary",
                  class: "check-eligibility-btn no-shadow no-text-transform",
                  enable: binForm.value.isBinFilled(),
                  onClick: _cache[25] || (_cache[25] = ($event: any) => (checkBin()))
                }, {
                  default: _withCtx(() => [
                    (binForm.value.isLoading)
                      ? (_openBlock(), _createBlock(SpinnerComponent, {
                          key: 0,
                          color: "black"
                        }))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(_toDisplayString(_unref(t)('authModal.register.binForm.checkEligibilityBtn')), 1)
                        ], 64))
                  ]),
                  _: 1
                }, 8, ["enable"]))
              : _createCommentVNode("", true),
            (!_unref(isMobile) || (binForm.value.isBinEmpty() && !binForm.value.isBinFocused))
              ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("span", _hoisted_28, _toDisplayString(_unref(t)('or')), 1)
                  ]),
                  _createVNode(ButtonComponent, {
                    class: "bordered no-text-transform black",
                    onClick: _cache[26] || (_cache[26] = ($event: any) => (switchToSignIn()))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('signIn')), 1)
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
          ]))
  ]))
}
}

})